module.exports = __webpack_public_path__ + "img/1531628743.02a4fecf.jpg";